import { useTranslation } from "react-i18next";
import { PublicClinicShell } from "./components/PublicClinicShell";

export function PrivacyPolicyPage() {
  const { t } = useTranslation(["landing"]);

  return (
    <PublicClinicShell
      seo={{
        title: t("landing:seo.privacy_title"),
        description: t("landing:seo.privacy_description"),
        path: "/privacy-policy",
      }}
    >
      <main className="flex-grow max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {t("landing:privacy.title")}
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          {t("landing:privacy.updated")}
        </p>

        <div className="space-y-6 text-card-foreground/90 leading-relaxed text-justify">
          <p>{t("landing:privacy.intro")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section1_title")}
          </h2>
          <p>{t("landing:privacy.section1_body_a")}</p>
          <p>{t("landing:privacy.section1_body_b")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section2_title")}
          </h2>
          <p>{t("landing:privacy.section2_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section3_title")}
          </h2>
          <p>{t("landing:privacy.section3_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section4_title")}
          </h2>
          <p>{t("landing:privacy.section4_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section5_title")}
          </h2>
          <p>{t("landing:privacy.section5_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:privacy.section6_title")}
          </h2>
          <p>{t("landing:privacy.section6_body")}</p>
        </div>
      </main>
    </PublicClinicShell>
  );
}
